module.exports = __webpack_public_path__ + "img/b3.9a22e4f2.png";